import {
    bymoTemplateMetadataFactoryCreate,
    DoppePaletteColorType,
    DoppeTemplateColor,
    doppeTemplateColorCreateLegibleColor,
    doppeTemplateColorCreatePaletteBoundColor
} from "../../../doppe-sdk";

export namespace BymoTemplateBasic {

    export interface TemplateProps {
        mainColor: DoppeTemplateColor;
        skipButtonBackgroundColor: DoppeTemplateColor;
        backgroundColor: DoppeTemplateColor;
        mainTextColor: DoppeTemplateColor;
        skipButtonTextColor: DoppeTemplateColor;
    }
}

const initialValues = {
    backgroundColor: doppeTemplateColorCreatePaletteBoundColor(DoppePaletteColorType.Background),
    mainColor: doppeTemplateColorCreatePaletteBoundColor(DoppePaletteColorType.Main),
    skipButtonBackgroundColor: doppeTemplateColorCreatePaletteBoundColor(DoppePaletteColorType.Secondary),
    mainTextColor: doppeTemplateColorCreatePaletteBoundColor(DoppePaletteColorType.Text),
    skipButtonTextColor: doppeTemplateColorCreateLegibleColor(DoppePaletteColorType.Secondary),
} as BymoTemplateBasic.TemplateProps;

export const BymoTemplateBasicTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateBasic.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {},
    features: [
        'hasActions',
        'hasActionButton',
        'canBeSkipped',
        'hasProfileContent',
        'hasVisibleBackground',
        'hasCustomTextualContent'
    ]
})